module.exports = __webpack_public_path__ + "gw.svg?6c6e90fac2cf2f4cab03d1a855a762a5";